export default __webpack_public_path__ + "static/media/lk.dd02e7e3.svg";